<section class="checkout-items" *ngIf="cart?.cartItems?.length">
  <p class="checkout-items__eyebrow" i18n="@@checkout.items.eyebrow">購物車商品 Cart Items</p>

  <div class="checkout-items__row"
       *ngFor="let item of cart.cartItems; let last = last"
       [class.checkout-items__row--last]="last">
    <div class="checkout-items__thumb">
      <img *ngIf="imageOf(item)" [src]="imageOf(item)" [alt]="nameOf(item).zh">
    </div>

    <div class="checkout-items__name">
      <p class="checkout-items__name-zh">{{ nameOf(item).zh }}</p>
      <p class="checkout-items__name-en" *ngIf="nameOf(item).en">{{ nameOf(item).en }}</p>
    </div>

    <div class="checkout-items__qty">
      <button type="button"
              class="checkout-items__qty-btn"
              [disabled]="item.quantity <= 1"
              (click)="onSubtract(item)">−</button>
      <span class="checkout-items__qty-value">{{ item.quantity }}</span>
      <button type="button"
              class="checkout-items__qty-btn"
              (click)="onAdd(item)">+</button>
    </div>

    <p class="checkout-items__price"
       [class.checkout-items__price--sale]="isSalesPrice(item.productSku)">
      $ {{ item.grandTotal | number }}
    </p>

    <button type="button"
            class="checkout-items__remove"
            i18n-aria-label="@@checkout.items.remove.aria"
            aria-label="Remove item"
            (click)="onRemove(item)">✕</button>
  </div>
</section>
